// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoTip_wrapper__h+Q29","icon":"InfoTip_icon__eaqh0","bubble":"InfoTip_bubble__1jnSi","bubbleRight":"InfoTip_bubbleRight__7XBcz"};